import React, { useState } from 'react'
import { Divider } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'
import { formatDigits } from '../../appRedux/actions'

const PaymentPanelSummaryHelper_1 = props => {
  const dispatch = useDispatch()
  const getCurrData = props.getCurrData
    ? props.getCurrData
    : {
        currencyCode: '',
        currencyName: '',
        currencySymbol: ''
      }
  const getSaleOrderJson = useSelector(
    ({ MainSale }) => MainSale.getSaleOrderJson
  )
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getSalePayments = useSelector(
    ({ MainSale }) => MainSale.getSalePayments
  )
  const getSavings = useSelector(({ MainSale }) => MainSale.getTotalSaving)

  return (
    <>
      <Divider className='custom-promolist-divider' />
      <div className='dk-payment-panel-summary-flex-child'>
        <div className='dk-sell-summary-line'>
          <strong>
            <IntlMessages id='sell.sell.saletotal' />
          </strong>
          {getSaleOrderJson && getSaleOrderJson.totalItems && (
            <span className='dk-text--sub'>
              {` ${getSaleOrderJson.totalItems} `}
              {getSaleOrderJson.totalItems > 1 ? (
                <IntlMessages id='sell.sell.items' />
              ) : (
                <IntlMessages id='sell.sell.item' />
              )}
            </span>
          )}
        </div>
        <div className='dk-sell-summary-line'>
          {getCurrData.currencyCode != null
            ? getCurrData.currencyCode
            : getCurrData.currencyName != null
            ? getCurrData.currencyName
            : getCurrData.currencySymbol}{' '}
          {getSaleOrderJson != undefined && getSaleOrderJson.finals != undefined
            ? getSaleOrderJson.finals.inc != undefined
              ? formatDigits(
                  getSaleOrderJson.finals.inc,
                  getDefaultDecimalPlaces
                )
              : ' '
            : ''}
        </div>
      </div>
      <div className='dk-mg-lft no-mar-left'>
        {getSalePayments &&
          getSalePayments.map((paymentObject, index) => {
            return (
              <div className='custom-mg-bt' key={index}>
                <Divider className='custom-promolist-divider' />
                <div className='dk-payment-panel-summary-flex-child'>
                  <div className='dk-sell-summary-line'>
                    <div className=' dk-sell-summary-linedk-mg-btm-auto'>
                      {paymentObject.paymentName}
                    </div>

                    <div className='dk-text-supplementary'>
                      {paymentObject.paymentDate}
                    </div>
                  </div>
                  <div className='dk-sell-summary-line'>
                    {getCurrData.currencyCode != null
                      ? getCurrData.currencyCode
                      : getCurrData.currencyName != null
                      ? getCurrData.currencyName
                      : getCurrData.currencySymbol}{' '}
                    {formatDigits(
                      paymentObject.amount,
                      getDefaultDecimalPlaces
                    )}
                  </div>
                </div>
              </div>
            )
          })}
        <Divider className='custom-promolist-divider' />
        {getSaleOrderJson.Change != undefined && getSaleOrderJson.Change > 0 ? (
          <>
            <div className='dk-payment-panel-summary-flex-child'>
              <div className='dk-sell-summary-line'>
                <strong>
                  <IntlMessages id='sell.sell.change' />
                </strong>
              </div>
              <div className='dk-sell-summary-line'>
                {getCurrData.currencyCode != null
                  ? getCurrData.currencyCode
                  : getCurrData.currencyName != null
                  ? getCurrData.currencyName
                  : getCurrData.currencySymbol}{' '}
                {formatDigits(getSaleOrderJson.Change, getDefaultDecimalPlaces)}
              </div>
            </div>
          </>
        ) : (
          ''
        )}

        <div className='dk-payment-panel-summary-flex-child'>
          <div className='dk-sell-summary-line'>
            <strong>
              <IntlMessages id='sell.sell.topay' />
            </strong>
          </div>
          <div className='dk-sell-summary-line'>
            {getCurrData.currencyCode != null
              ? getCurrData.currencyCode
              : getCurrData.currencyName != null
              ? getCurrData.currencyName
              : getCurrData.currencySymbol}{' '}
            {formatDigits(
              getSaleOrderJson.AmountToPay,
              getDefaultDecimalPlaces
            )}
          </div>
        </div>
        {getSaleOrderJson && getSaleOrderJson.Notes && (
          <>
            <Divider className='custom-promolist-divider' />
            <div className='sale-note'>
              <IntlMessages id='sell.sell.note' />
              {` ${getSaleOrderJson.Notes}`}
            </div>
          </>
        )}
      </div>
      {getSavings != '' && (
        <div className='dk-payment-panel-summary-flex-child total-bar'>
          <Divider className='custom-promolist-divider' />
          <div className='TS-div d-flex align-items-center justify-content-between'>
            <div className='dk-sell-summary-line'>
              <strong>
                <IntlMessages id='sell.sell.totalsavings' />
              </strong>
            </div>
            <div className='dk-sell-summary-line'>
              {getCurrData.currencyCode != null
                ? getCurrData.currencyCode
                : getCurrData.currencyName != null
                ? getCurrData.currencyName
                : getCurrData.currencySymbol}
              {` ${getSavings}`}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default PaymentPanelSummaryHelper_1
